import type { ItemFieldRow } from './item-field-reader';
import { readInventoryField, readLayerListEntryUuid } from './inventory-raw-readers';
import { phpJsonInt, phpJsonTruthy } from './php-json-values';

/** The positive classification condition, shared with movement watcher admission. */
export function equippedWeaponClassificationMatches(row: ItemFieldRow, classification: string,
    read: { layerValue: (row: ItemFieldRow, key: string) => unknown; layerEntries: (row: ItemFieldRow, key: string) => unknown },
    slots: Readonly<Record<'main_hand' | 'off_hand' | 'both_hands', string>>): boolean {
    if (phpJsonInt(readInventoryField(row, 'inventory_private') ?? 0) === 2) return false;
    const value = read.layerValue(row, 'weapon_classification');
    return (value !== null || phpJsonTruthy(read.layerEntries(row, 'weapon_classification')))
        && readLayerListEntryUuid(value) === classification
        && [slots.main_hand, slots.off_hand, slots.both_hands].includes(String(readInventoryField(row, 'equipped') ?? ''));
}

/** Shared equipped-property gate for condition compilation and each striking weapon. */
export function equippedWeaponPropertyMatches(row: ItemFieldRow, property: string,
    read: { layerValue: (row: ItemFieldRow, key: string) => unknown; layerEntries: (row: ItemFieldRow, key: string) => unknown },
    slots: Readonly<Record<'main_hand' | 'off_hand' | 'both_hands', string>>): boolean {
    if (phpJsonInt(readInventoryField(row, 'inventory_private') ?? 0) === 2) return false;
    const equipped = readInventoryField(row, 'equipped') ?? '';
    return [slots.main_hand, slots.off_hand, slots.both_hands].includes(String(equipped))
        && (read.layerValue(row, property) != null || phpJsonTruthy(read.layerEntries(row, property)));
}
